import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { RowItem } from '../layout/RowItem';
import authService from '../api-authorization/AuthorizeService';
import AdminFunctions from './AdminFunctions';
import { useEffect } from 'react';

function Admin(props) {

    const navigate = useNavigate();

    //useEffect(async () => {
    //    const isAdmin = AdminFunctions.isAdminAsync();
    //    if (!isAdmin) {
    //        navigate('/accessdenied');
    //    }
    //})

    useEffect(() => {
        async function fetchIsAdmin() {
            const isAdmin = AdminFunctions.isAdminAsync();
            if (!isAdmin) {
                navigate('/accessdenied');
            }
        }
        fetchIsAdmin();
    })



    return (
        <div>
            <Container style={{ marginTop: '50px' }}>
                <RowItem>
                    <Col>
                        <h3>Admin</h3>
                    </Col>
                </RowItem>
                <RowItem>
                    <ul style={{ fontSize: '24px' }}>
                        <NavLink tag={Link} to='/admin/clients'>Clients</NavLink>
                        <NavLink tag={Link} to='/admin/roles'>Roles</NavLink>
                        <NavLink tag={Link} to='/admin/users'>Users</NavLink>
                    </ul>
                </RowItem>
            </Container>
        </div>
    )
}

export default Admin;